import { useMutation, useQueryClient } from 'react-query'
import { postJSON } from 'common/services/api'
import {
  TransferRecordPayload,
  TransferRecordResponse
} from 'types/transferRecord'

interface UseTransferRecordCreateParams {
  residentId: string
  onSuccess?: () => void
  onError?: (error: unknown) => void
}

export const useTransferRecordCreate = ({
  residentId,
  onSuccess,
  onError
}: UseTransferRecordCreateParams) => {
  const queryClient = useQueryClient()

  const createTransferRecord = async (payload: TransferRecordPayload) => {
    return postJSON({
      url: `/api/residents/${residentId}/transfer-records`,
      json: payload
    }) as Promise<{ result: TransferRecordResponse }>
  }

  const { mutateAsync, isLoading } = useMutation(
    [`create-transfer-record-${residentId}`],
    createTransferRecord,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['transfer-records', residentId])
        queryClient.invalidateQueries(['latest-transfer-record', residentId])
        onSuccess?.()
      },
      onError
    }
  )

  return { createTransferRecord: mutateAsync, isLoading }
}
